import { getStore } from "../store/store";
import { getDefaultFlexPaneWidth } from "../utils/getDefaultFlexPaneWidth";

/**
 * Returns the currently shown OWA FlexPane's width.
 */
export function getFlexPaneWidth(flexPaneId?: string): number {
    // Return currentFlexPaneState's width
    if (getStore().currentFlexPaneState.isShown && getStore().currentFlexPaneState.isExpanded) {
        return getStore().currentFlexPaneState.expandedWidth;
    }
    else {
        return getDefaultFlexPaneWidth(flexPaneId); // FlexPane is not shown, still return default width for TaskPanes or other panes
    }
}
